// extracted by mini-css-extract-plugin
module.exports = {"personalAreaWrapper":"personal-area_personalAreaWrapper__NEyDV"};